export enum Rights {
  FUX = 1,
  BURSCHE = 10,
  MODERATOR = 100,
  ADMIN = 1000,
}
